<template>
  <BaseDataTable
    :data="data"
    :meta="meta"
    :columns="tableColumns"
    :loading="loading"
    multipleEntityTypes
  >
    <template #no-data>
      <NoResources />
    </template>
  </BaseDataTable>
</template>
<script lang="ts" setup>
// Utils
import { computed } from 'vue'

// Components
import NoResources from "@/modules/resources/components/NoResources.vue";

// Composables
import { useStore } from "vuex"
const store = useStore()

const props = defineProps({
  data: {
    type: Array,
    default: () => []
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const tableColumns = computed(() => {
  return store.getters['resources/tableColumns'] || []
})

const meta = computed(() => {
  return store.state.resources.resources.meta || {}
})
</script>
